var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	13732: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(96540); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	1995: {
		fallback: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(3732)]).then(function() { return function() { return __webpack_require__(74848); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	10865: {
		fallback: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(6417), __webpack_require__.e(6056), __webpack_require__.e(8122), __webpack_require__.e(8845)]).then(function() { return function() { return __webpack_require__(86715); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	81924: {
		fallback: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	33224: {
		fallback: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(1106)]).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	59914: {
		fallback: function() { return Promise.all([__webpack_require__.e(6417), __webpack_require__.e(8122), __webpack_require__.e(6066)]).then(function() { return function() { return __webpack_require__(28133); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	38006: {
		fallback: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	44178: {
		fallback: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	18712: {
		fallback: function() { return __webpack_require__.e(2140).then(function() { return function() { return __webpack_require__(29759); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	57733: {
		fallback: function() { return __webpack_require__.e(8501).then(function() { return function() { return __webpack_require__(30882); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	99247: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	8122: {
		fallback: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(3732)]).then(function() { return function() { return __webpack_require__(40961); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	50932: {
		fallback: function() { return Promise.all([__webpack_require__.e(3540), __webpack_require__.e(3732)]).then(function() { return function() { return __webpack_require__(33540); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-components",
	},
	86567: {
		fallback: function() { return __webpack_require__.e(9785).then(function() { return function() { return __webpack_require__(49785); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-hook-form",
	},
	39756: {
		fallback: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(3732), __webpack_require__.e(8122), __webpack_require__.e(1002)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "13.5.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	20516: {
		fallback: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(1106), __webpack_require__.e(2981)]).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "13.5.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	29429: {
		fallback: function() { return __webpack_require__.e(6914).then(function() { return function() { return __webpack_require__(46914); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.0.19",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-map-gl",
	},
	92637: {
		fallback: function() { return __webpack_require__.e(2266).then(function() { return function() { return __webpack_require__(60842); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.11.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "mapbox-gl",
	},
	65460: {
		fallback: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "13.5.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [13732,1995,10865,81924,33224,59914,38006,44178,18712,57733,13732,99247,8122,1995,10865,50932,20516,65460];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"516": [
		20516
	],
	"636": [
		1995,
		10865,
		50932
	],
	"865": [
		10865
	],
	"932": [
		50932
	],
	"1995": [
		1995
	],
	"2637": [
		92637
	],
	"3332": [
		65460
	],
	"3732": [
		13732
	],
	"5527": [
		81924,
		33224,
		59914,
		38006,
		44178,
		18712,
		57733
	],
	"6567": [
		86567
	],
	"8122": [
		8122
	],
	"8792": [
		13732,
		99247,
		8122
	],
	"9429": [
		29429
	],
	"9756": [
		39756
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}